import Autocomplete from "@mui/lab/Autocomplete";
import TextField from "@mui/material/TextField/TextField";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

interface AppOption {
  label: string;
  id: number;
}

interface Props {
  onSelect?: (app: AppOption | null) => void;
}

export const NotificationsTargetApp = ({ onSelect }: Props) => {
  const whiteLabels = useSelector((s: any) => s.cities?.whiteLabels as any[]);

  const whiteLabelOptions: AppOption[] = useMemo(() => {
    return whiteLabels
      ? whiteLabels.map((wl: any) => {
          return {
            label: wl.name,
            id: wl.id || 0,
          };
        })
      : [];
  }, [whiteLabels]);

  return (
    <Autocomplete
      options={whiteLabelOptions}
      onChange={(_, value) => onSelect?.(value)}
      renderInput={(params) => (
        <TextField {...params} label="App" placeholder="Select App" />
      )}
    />
  );
};
